<template>
    <!-- star -->
  
<div class="download_wrap">
      <!-- <banner2 :bannerH="h1" :bannerP="p1" :bannerImg="Img1"></banner2> -->
      <!-- 面包屑 -->
      <!-- <div class="Crumbs">
        <div>当前位置：首页><span>金融</span></div>
      </div> -->
      <!-- 招聘信息 -->
      <div class="download">
          <div class="download-cell" v-for="(item, index) in arrList" :key="index">
            <img class="download-img" :src="item.banner" alt="" />
            <div class="download-content">
                <h1>{{item.title}}</h1>
                <p>{{item.introduce}}</p>
                <div class="download-cord">
                    <div class="download-button">
                        <div>
                          <a class="iPhone-button" href="#">
                            <img src="@/assets/img/icon_ios.png" alt="" />
                            iPhone版下载
                          </a>
                          <a class="Android-button" href="#">
                            <img src="@/assets/img/icon_android.png" alt="" />
                            Android版下载
                          </a>
                        </div>
                    </div>
                    <img class="dowCord-img" :src="item.cordImg" alt="" />
                </div>
            </div>
          </div>
      </div>
      <!-- 翻页 -->
      <!-- <Pages></Pages> -->
  
      <!-- end -->
    </div>
  </template>
  
  
  <script>
//   import banner2 from "../components/banner.vue";
//   import Pages from "../components/recruitInfoPages.vue";
  export default {
    name: "download",
    components: {
    //   banner2,
    //   Pages,
    },
    data() {
      return {
        arrList: [
          {
            id: 1,
            banner: require('@/assets/download/downimg_bg01.png'),
            cordImg: require('@/assets/img/ewm.jpg'),
            title: '变压器监测仪',
            introduce: '系统采用 TEV/AE/UHF 等检测手段实时监测电缆头局放状态，测温探头固定在电缆头处，实时检测温升变化，通过与电力负荷关联，以大数据方式判断电缆温升正常与否，此外系统还配置了电缆沟/井温湿度及浸水检测功能，随时监测电缆运行环境变化情况。',
          },
          {
            id: 2,
            banner: require('@/assets/download/downimg_bg02.png'),
            cordImg: require('@/assets/img/ewm.jpg'),
            title: '变压器监控运维管理系统',
            introduce: '正能电力运维监控平台”是针对变压器(干式/油式)运行状态进行监测而研发的一套可视化系统，具有用电数据(电压电流、功率、功率因数、电量，最大需量、电费等)采集、温度监测、故障报警和远程运维等功能。',
          },
          {
            id: 3,
            banner: require('@/assets/download/downimg_bg03.png'),
            cordImg: require('@/assets/img/ewm.jpg'),
            title: '智慧物联网开关系统',
            introduce: '物联网开关虽然名称是开关，但已经超越了普通开关单纯合分闸的作用，它与控制 /保护对象构成一个数据节点，实现对象各种电量/非电量数据的“泛在聚合”，可以方便的检索所需的各类数据，在系统后台数学分析模型支撑下，不断挖据这些数据所代表的开关及控制对象之间普遍存在的复杂联系，实现对控制对象认知的飞跃，进而不断提升人们生活的安全性和便利度。物联网开关得到系统支持是具备思维能力的“聪明”开关，是对普通开关的颠覆性变革。在智能家居、商业综合体等人流密集的地方，物联网开关在为人们提供便利的同时，其对电能质量的全面监测功能为人民群众的幸福生活奠定了坚实的安全基础。',
          },
          {
            id: 4,
            banner: require('@/assets/download/downimg_bg04.png'),
            cordImg: require('@/assets/img/ewm.jpg'),
            title: '配电房用电管理系统',
            introduce: '"云-管-边-端"作为物联网的主要发展形式，正在越来越快地改变传统行业。云计算、多种多样的通讯方式、边缘计算、智能终端等潮流新技术日益融入传统的电力设备行业老设备经过信息化赋能，焕发出超越用户期望的新价值。传统的配电房实现无人值守、自主运行，设备信息化是必由之路。',
          }
        ],
      };
    },
    methods: {
      
      
    },
  };
  </script>
<style scoped>
@import "../assets/css/recruit-info.css";
.download-img{
    width: 100%;
    display: block;
    min-width: 1400px
}
.download-cell{
  position: relative;
}
.download-cell .download-content{
    position: absolute;
    bottom: 200px;
    z-index: 2; 
    width: 400px;
    color: #ffffff;
}
.download-cell:nth-child(odd) .download-content{
    right: 18%;
}
.download-cell:nth-child(even) .download-content{
    left: 18%;
}
.download-content h1{
  font-size: 24px;
  color: #ffffff;
}
.download-content p{
  margin-top: 30px;
  line-height: 25px;
  font-size: 14px;
}
.download-cord{
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  margin-top: 50px
}
.dowCord-img{
  width: 100px
}
.download-button{
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  width: 150px;
}
.download-button a{
  display: block;
  width: 200px;
  padding: 0 15px;
  text-align: center;
  height: 40px;
  margin-bottom: 12px;
  line-height: 40px;
  font-size: 14px;
  border-radius: 3px;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
    justify-content: center;
}
.download-button a img{
  width: 20px;
  margin-right: 5px
}
.download-button a.iPhone-button{
  background: rgba(255, 255, 255, 0.2);
}
.download-button a.Android-button{
  background: #4CCE9D;
  margin-bottom: 0;
}
</style>
  
  
  